import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {EventModel, EventParticipantModel, NotificationModel} from '@/libs/Api';
import {NotificationsDataService} from '@/libs/notifications/notifications-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const notificationsStore = registerCrudStore<NotificationModel, NotificationModel>(StoreName.Notification, new NotificationsDataService());
